<template>
<nav class="navbar is-white is-fixed-top" role="navigation"
  aria-label="main navigation">
  <container>
    <navbar-items :title="title" :subtitle="subtitle" :links="links" />
    <div class="navbar-brand">
      <div class="navbar-burger">
      </div>
      <router-link class="navbar-item" to="/">
        <hv-image :src="logoUrl" alt="HireVibes" size="is-32x32"
          :is-rounded="false" />
      </router-link>
      <a class="navbar-burger" @click="navbarMenuClicked"
        :class="{ 'is-active': isExpanded }">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <navbar-items v-if="user" :title="title" :subtitle="subtitle" :links="links"
      class="mobile" :class="{ 'is-active': isExpanded }" />
    <navbar-end :class="{ 'is-active': isExpanded }" :login="login"
      :signup="signup" />
  </container>
  <div class="loading-indicator" v-if="loading" :style="'width:' +loadingPercentage+ '%'"></div>
</nav>
</template>

<script>
import HvLogo from '@/assets/hv-logo.svg'
import NavbarInfo from '@/components/navbar/navbar-info'
import HvImage from '@/components/general/image'
import NavbarItems from '@/components/navbar/navbar-items'
import NavbarEnd from '@/components/navbar/navbar-end'
import Container from '@/components/general/container'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    NavbarInfo, HvImage, NavbarItems, NavbarEnd, Container
  },
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    login: {
      default: false
    },
    signup: {
      default: false
    },
    showLinks: {
      default: true
    }
  },
  data () {
    return {
      isExpanded: false
    }
  },
  methods: {
    ...mapActions('users', [
      'getUser',
      'getCurrentUserInfo'
    ]),
    navbarMenuClicked () {
      this.isExpanded = !this.isExpanded
    }
  },
  mounted () {
    if (this.loggedIn) {
      this.getCurrentUserInfo()
      this.getUser()
    }
    if (this.enableIntercom) {
      this.$intercom.boot({ name: 'Guest' })
    }
    document.documentElement.classList.add('has-navbar-fixed-top')
  },
  watch: {
    '$route' (to, from) {
      this.isExpanded = false
    },
    authType: function (oldType, newType) {
      if (this.loggedIn) {
        this.getUser()
        this.getCurrentUserInfo()
      }
    },
    user: {
      deep: true,
      handler: function (user) {
        if (user.profile === 'unknown') {
          this.$router.push('/signup-type')
        }
      }
    },
    intercomUser: {
      deep: true,
      handler: function (u) {
        if (this.enableIntercom) {
          if (u) {
            this.$intercom.update({ user_id: u.id, name: `${u.firstName} ${u.lastName}`, email: u.email, custom_launcher_selector: '.open_intercom' })
          } else {
            this.$intercom.update({ user_id: null, name: 'Guest', custom_launcher_selector: '.open_intercom' })
          }
        }
      }
    }
  },
  computed: {
    enableIntercom () {
      return !this.$route.meta.disableIntercom
    },
    ...mapState('loading', ['loading', 'loadingPercentage']),
    ...mapState('users', [
      'user',
      'intercomUser'
    ]),
    ...mapGetters('users', [
      'profilePictureUrl'
    ]),
    ...mapState('statuses', {
      messageCount: 'messages'
    }),
    logoUrl () {
      return HvLogo
    },
    loggedIn () {
      return this.authType !== 'unauth'
    },
    authType () {
      return this.$route.meta.authType
    },
    links () {
      // console.log(this.user)
      const msgPost = this.messageCount > 0 ? `(${this.messageCount})` : ''
      if (this.loggedIn && this.showLinks) {
        if (!this.user) {
          return [{
            title: this.$t('nav.jobs'),
            to: '/jobs'
          }]
        }
        let links = [{
          title: this.$t('nav.jobs'),
          to: '/jobs'
        }, {
          title: this.$t('nav.jobseekers'),
          to: '/jobseekers'
        }, {
          title: `${this.$t('nav.messages')} ${msgPost}`,
          to: '/messages'
        }, {
          title: this.$t('nav.referrals'),
          to: '/referrals'
        }]
        if (this.user.profile === 'hirer') {
          links.splice(3, 1)
        }
        if (this.user && (this.user.isAdmin || this.user.profile === 'hirer')) {
          links.push({
            title: this.$t('nav.admin'),
            to: '/admin'
          })
        }
        return links
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

div.navbar-brand {
  margin-left: auto !important;
  margin-right: auto;
}

.navbar {
  min-height: $navbar-height;
}

.navbar > container {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
}

.items,
.navbar-menu {
  width: 40%;
}

.navbar-brand {
  justify-content: center;
  min-height: $navbar-height;
}

a.navbar-item {
  text-decoration: none;
}

.navbar-burger {
  min-height: $navbar-height;
  position: relative;
  right: -21px
}

@media screen and (min-width: $tablet) {
  .mobile {
    display: none;
  }
}

@media screen and (max-width: $tablet) {
  .navbar .navbar-menu {
    background-color: inherit;
    color: #111111;
    width: 100%;
  }
  .is-divider-vertical {
    display: inline-block;
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: auto;
    height: auto;
    padding: 2rem;
    margin: 0;
    position: relative;
    border-top: none;
    min-height: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar.vue